<div id="chat-page">
  
  <div class="container">
   
    <div id="check-top"></div>
    <div class="padding-top-2"></div>
    <div class="flex-center loading margin-top-1" *ngIf="loading">
      <mat-spinner color="accent" diameter="50"></mat-spinner>
    </div>
    
    <div
      class="chats margin-top-1"
      [style.margin-bottom]="form.value.file ? '150px' : '130px'"
    > 
   
      <div *ngFor="let message of messages" [id]="'message-' + message.id">
        <div [class]="message.align">
          <div
            [class]="'margin-bottom-1 ' + message.type"
            (click)="onMessageClick(message)"
          >
            <div
              *ngIf="message.files.length"
              class="padding-bottom-1"
              [class.flex-start]="message.type === 'message-received'"
              [class.flex-end]="message.type === 'message-sent'"
            >
              <div>
                <mat-icon [style.color]="'#54656f'" class="margin-right-05">
                  <ng-container [ngSwitch]="message.files[0].type">
                    <ng-container *ngSwitchCase="'document'">
                      description
                    </ng-container>
                    <ng-container *ngSwitchCase="'image'"> image </ng-container>
                    <ng-container *ngSwitchCase="'video'">
                      videocam
                    </ng-container>
                    <ng-container *ngSwitchCase="'audio'">
                      music_note
                    </ng-container>
                  </ng-container>
                </mat-icon>
              </div>
              <div>
                {{ message.files[0].name }}
              </div>
            </div>
            <div>{{ message.content }}</div>
            <div class="date gray mat-caption">
              {{ message.date_human_readable }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="chat-form padding-vertical-1"
    [style.width]="chatPageWidth + 'px'"
  >
  <div class="collapse-chat-list" padding>
    <button (click)="showConversations()" class="button-show-conversations"><i class="far fa-arrow-alt-circle-left"></i></button>
  </div>
    <div class="container margin-bottom-1" *ngIf="form.value.file">
      

      <span>{{ form.value.file.name }}</span>
      <mat-icon class="remove-file-icon" (click)="removeFile()">clear</mat-icon>
    </div>
    
    <form [formGroup]="form" (ngSubmit)="sendMessage()" >
      <div [class]="{ minimized: minimized, container: true }">
       
        <div class="button-file flex-start icon-attach">
          <button mat-icon-button type="button" [matMenuTriggerFor]="chatMenu">
            <mat-icon style="color: #ffffff">attach_file</mat-icon>
          </button>

          <mat-menu #chatMenu="matMenu">
            <ng-template matMenuContent>
              <button mat-menu-item (click)="file.click()">
                {{ "documents" | translate }}
              </button>
              <button mat-menu-item (click)="imageVideo.click()">
                {{ "photos-and-videos" | translate }}
              </button>
              <button mat-menu-item (click)="sound.click()">
                {{ "sounds" | translate }}
              </button>
            </ng-template>
          </mat-menu>
          <!-- Inpputd -->
          <div style="display: none">
            <input
              type="file"
              #imageVideo
              accept=".png,.jpeg,.jpg,.gif,.mp4,.mpg,.avi"
              (change)="onFileSelect($event.target)"
            />
            <input
              type="file"
              #file
              accept=".pdf,.xls,.doc,.docx"
              (change)="onFileSelect($event.target)"
            />
            <input
              type="file"
              #sound
              accept=".mp3"
              (change)="onFileSelect($event.target)"
            />
          </div>
        </div>
        <div class="input flex-center">
          <textarea cdkTextareaAutosize
            rows="3"
            class="width-100 msg-write-area"
            [placeholder]="'write-something' | translate"
            formControlName="message"
          ></textarea>
        </div>
        <div class="button-send flex-center">
          <button 
            mat-icon-button
            [disabled]="form.invalid"
            type="submit"
            *ngIf="!sendingMessage; else sendingTemplate"
          >
            <mat-icon [style.color]="form.invalid ? '#54656f' : '#FFF'"
              >send</mat-icon
            >
          </button>
          <ng-template #sendingTemplate>
            <div style="padding-left: 5px">
              <mat-spinner color="primary" diameter="20"></mat-spinner>
            </div>
          </ng-template>
        </div>
      </div>
    </form>
  </div>
</div>
